import { MessageCircle, Instagram } from "lucide-react";
import { COMPANY } from "@/lib/data";

export default function WhatsAppFab() {
  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col items-center gap-3">
      <a
        href="https://www.instagram.com/teknosura/"
        target="_blank"
        rel="noreferrer"
        aria-label="Instagram"
        className="group relative flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br from-[#f09433] via-[#e6683c] to-[#bc1888] text-white shadow-[0_8px_24px_rgba(188,24,136,0.35)] transition-transform duration-300 hover:scale-110"
        data-testid="instagram-fab"
      >
        <Instagram className="h-6 w-6" />
        <span className="absolute inset-0 -z-10 animate-ping rounded-full bg-[#e6683c]/40" />
      </a>
      <a
        href={`https://wa.me/${COMPANY.whatsapp}`}
        target="_blank"
        rel="noreferrer"
        aria-label="WhatsApp"
        className="group relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_rgba(37,211,102,0.45)] transition-transform duration-300 hover:scale-110"
        data-testid="whatsapp-fab"
      >
        <MessageCircle className="h-7 w-7" />
        <span className="absolute inset-0 -z-10 animate-ping rounded-full bg-[#25D366]/40" />
      </a>
    </div>
  );
}
